<template>
  <div class="ad-banner-page" v-if="currentUser">
    <div class="page-header">
      <div class="page-header-left">
        <router-link to="/admin-profile/ad-banners" class="back-link">
          &#8592; Powrót do listy banerów
        </router-link>
        <h1>Nowy baner reklamowy</h1>
      </div>
    </div>

    <AdBannerForm @saved="onSaved" />
  </div>
</template>

<script>
import AdBannerForm from '@/components/AdBannerForm.vue';
import { useAuthStore } from '@/stores/auth';

export default {
  name: 'AdBannerCreate',
  components: { AdBannerForm },
  setup() {
    return {
      authStore: useAuthStore(),
    };
  },
  computed: {
    currentUser() {
      return this.authStore.user;
    },
  },
  mounted() {
    if (!this.currentUser) {
      this.$router.push('/login');
      return;
    }

    if (this.currentUser.role_id !== 1) {
      this.$router.push('/login');
    }
  },
  methods: {
    onSaved(banner) {
      if (banner && banner.id) {
        this.$router.push(`/admin-profile/ad-banners/edit/${banner.id}`);
      } else {
        this.$router.push('/admin-profile/ad-banners');
      }
    },
  },
};
</script>

<style scoped lang="scss">
.ad-banner-page {
  max-width: 1400px;
  margin: 0 auto;
  padding: 32px 16px;
  font-family: sans-serif;
  box-sizing: border-box;
}

.page-header {
  margin-bottom: 24px;
  padding-bottom: 16px;
  border-bottom: 2px solid #e5e7eb;
}

.back-link {
  display: inline-block;
  font-size: 1.4rem;
  color: #10b981;
  text-decoration: none;
  font-weight: 600;
  margin-bottom: 8px;
  transition: color 0.2s;
}

.back-link:hover {
  color: #059669;
}

.page-header h1 {
  font-size: 2.8rem;
  font-weight: 700;
  color: #1f2937;
  margin: 0;
}

@media (max-width: 640px) {
  .ad-banner-page {
    padding: 16px 12px;
  }

  .page-header h1 {
    font-size: 2.2rem;
  }
}
</style>